import { obterParametrosDaURL } from "../../../../functions";
import { IRetornoPaginadoApi, TNotificacaoDoAplicativo } from "../../../../interfaces";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

type TRetornoObterNotificacoes = IRetornoPaginadoApi & {
    dado: TNotificacaoDoAplicativo[];
}

export const ObterNotificacoes = async (CurrentPage: number): Promise<TRetornoObterNotificacoes> => {

    const { token } = obterParametrosDaURL();

    try {

        const { data } = await api.get<TRetornoObterNotificacoes>(
            `/Notificacoes`
            +`?Token=${token}`
            +`&Paginacao.CurrentPage=${CurrentPage}`
            +`&Paginacao.Limit=${10}`
        );

        return data;

    } catch (erro) {
        throw new ApiException(
            erro,
            "Erro ao buscar notificações do aplicativo"
        );
    }
}